import * as XLSX from 'xlsx';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function DownloadExcelAnalytics(deliveries, selectedDate, userId) {
  const dateStr = selectedDate.replace(/-/g, '');

  // ── Sheet 1: Regular deliveries ─────────────────────────────
  const headers = [
    "ID", "Destinatario", "Teléfono", "Dirección", "Distrito",
    "Producto", "Estado", "Por Cobrar", "Cobrado",
    "Fecha Entrega", "Hora Llegada", "Notas", "Notas Conductor"
  ];

  const rows = deliveries.map(delivery => {
    const totalCobrado = parseFloat(delivery.charged || 0) + parseFloat(delivery.fastmax_transfer_amount || 0);
    return [
      delivery.id || '',
      delivery.recipient_name || '',
      delivery.recipient_phone || '',
      delivery.address || '',
      delivery.district || '',
      delivery.product || '',
      delivery.status || '',
      delivery.charge ? `S/ ${parseFloat(delivery.charge).toFixed(2)}` : '',
      totalCobrado > 0 ? `S/ ${totalCobrado.toFixed(2)}` : '',
      delivery.delivery_date ? new Date(delivery.delivery_date).toLocaleDateString('es-PE') : '',
      delivery.arrival_time ? new Date(delivery.arrival_time).toLocaleString('es-PE') : '',
      delivery.notes || '',
      delivery.notes_driver || ''
    ];
  });

  // ── Postergados section
  const postponedHeaders = [
    "ID", "Destinatario", "Teléfono", "Dirección", "Distrito",
    "Producto", "Estado", "Tienda", "Motivo Postergación", "Postergado Desde"
  ];

  let postponedRows = [];
  try {
    const res = await axios.get(`${API_URL}/api/delivery-points/postponed`, {
      params: {
        date: selectedDate,
        user_id: userId,
      },
    });
    const postponed = Array.isArray(res.data) ? res.data : (res.data.deliveries ?? []);
    postponedRows = postponed.map(d => [
      d.id || '',
      d.recipient_name || '',
      d.recipient_phone || '',
      d.address || '',
      d.district || '',
      d.product || '',
      d.status || '',
      d.username || '',
      d.postponed_reason || '',
      d.postponed_from_date
        ? new Date(d.postponed_from_date).toLocaleDateString('es-PE')
        : ''
    ]);
  } catch (err) {
    console.error('Error fetching postponed deliveries for Excel:', err);
  }

  // ── Build single sheet: entregas + blank row + postergados ──
  const blankRow = ['']; // blank separator row
  const postergadosTitleRow = ['── POSTERGADOS ──'];

  const allData = [
    headers,
    ...rows,
    blankRow,
    postergadosTitleRow,
    postponedHeaders,
    ...postponedRows,
  ];

  const ws1 = XLSX.utils.aoa_to_sheet(allData);
  ws1['!cols'] = [
    { wch: 8 }, { wch: 25 }, { wch: 15 }, { wch: 40 }, { wch: 20 },
    { wch: 30 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
    { wch: 15 }, { wch: 20 }, { wch: 30 }, { wch: 30 }
  ];

  // ── Build workbook ──────────────────────────────────────────
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws1, 'Entregas');

  XLSX.writeFile(wb, `Entregas_${dateStr}.xlsx`);
}

export function DownloadExcelProvinciaAnalytics(deliveries, selectedDate) {
  const dateStr = selectedDate.replace(/-/g, '');

  const headers = [
    "ID", "Destinatario", "DNI", "Teléfono", "Provincia", "Distrito",
    "Dirección", "Agencia", "Código Recojo", "Producto", "Estado",
    "Por Cobrar", "Anticipo", "Fecha Entrega", "Notas", "Comprobantes"
  ];

  const rows = deliveries.map(delivery => [
    delivery.id || '',
    delivery.recipient_name || '',
    delivery.recipient_dni || '',
    delivery.recipient_phone || '',
    delivery.province || '',
    delivery.district || '',
    delivery.address || '',
    delivery.agency_address || '',
    delivery.agency_pickup_code || '',
    delivery.product || '',
    delivery.status || '',
    delivery.charge ? `S/ ${parseFloat(delivery.charge).toFixed(2)}` : '',
    delivery.deposit_advance ? `S/ ${parseFloat(delivery.deposit_advance).toFixed(2)}` : '',
    delivery.delivery_date ? new Date(delivery.delivery_date).toLocaleDateString('es-PE') : '',
    delivery.notes || '',
    delivery.images && delivery.images.length > 0
      ? `${delivery.images.length} imagen(es)`
      : 'Sin imágenes'
  ]);

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  ws['!cols'] = [
    { wch: 8 }, { wch: 25 }, { wch: 12 }, { wch: 15 }, { wch: 20 }, { wch: 20 },
    { wch: 40 }, { wch: 35 }, { wch: 15 }, { wch: 30 }, { wch: 12 },
    { wch: 12 }, { wch: 12 }, { wch: 15 }, { wch: 30 }, { wch: 15 }
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Entregas Provincia');

  XLSX.writeFile(wb, `Entregas_Provincia_${dateStr}.xlsx`);
}
